'use strict';
const observable = require('@mindmup/mapjs-core/src/util/observable');

module.exports = function ReceiptsModel(taskBuilder) {
	const obj = observable(this);

	obj.loadReceipts = async () => {
		obj.dispatchEvent('loadingReceipts');
		try {
			const taskId = taskBuilder.newTaskId(),
				currentTask = await taskBuilder.build(taskId);
			await currentTask.execAndWaitFor('invoices/receipt/list', {}, (taskMetadata) => taskMetadata && taskMetadata.invoices);
			obj.dispatchEvent('loadedReceipts', currentTask.metadata.invoices);
			return currentTask.metadata.invoices;
		} catch (e) {
			obj.dispatchEvent('error', e);
			throw e;
		}
	};

	obj.loadUnpaidInvoices = async () => {
		obj.dispatchEvent('loadingUnpaidInvoices');
		try {
			const taskId = taskBuilder.newTaskId(),
				currentTask = await taskBuilder.build(taskId);
			await currentTask.execAndWaitFor('invoices/unpaid/list', {}, (taskMetadata) => taskMetadata && taskMetadata.invoices);
			obj.dispatchEvent('loadedUnpaidInvoices', currentTask.metadata.invoices);
			return currentTask.metadata.invoices;
		} catch (e) {
			obj.dispatchEvent('error', e);
			throw e;
		}
	};
};
